<template>
  <validation-observer
    v-if="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'owner-registered'"
      v-bind="observer"
      :validated="formObserver.validated"
    >
      <!-- OWNER AND REGISTERED -->
      <form-row
        id="owner-and-registered"
        :label="`Are you (or will you be) the owner and registered keeper of the ${['car', 'bike', 'motorhome'].includes(productName) ? productName : 'vehicle'}?`"
        :error="formObserver.validated && !observer.valid"
      >
        <template
          #helpText
        >
          <div class="d-flex align-start">
            <component
              :is="helpText && helpText.collapsible ? 'show-more' : 'div'"
              :open-text="helpText && helpText.collapsible ? (helpText.openerText || 'Show More') : false"
              :hide-text="helpText && helpText.collapsible ? (helpText.closerText || helpText.openerText || 'Hide') : false"
            >
              <div v-html="helpTextValue" />
            </component>
          </div>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_vehicle-owner-and-registered`"
          name="Vehicle owner and registered"
          rules="required"
        >
          <radio
            v-model="ownerAndRegistered"
            data-test="vehicle_owner_and_registered"
            name="driver_vehicle-owner-and-registered"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>
      <template v-if="ownerAndRegistered === false">
        <!-- OWNER -->
        <form-row
          id="owner-of-vehicle"
          :question="`Who is the owner of the ${['car', 'bike', 'motorhome'].includes(productName) ? productName : 'vehicle'}?`"
        >
          <validation-provider
            v-slot="{ errors }"
            :vid="`${stepId}_owner-of-vehicle`"
            name="Owner of vehicle"
            rules="listOptionRequired"
          >
            <qz-select
              v-model="questionData.ownerOfVehicle"
              :data-test="fieldTrackerId.ownerOfVehicle"
              :items="vehicleOwnerOfVehicle"
              :error-messages="errors"
              :placeholder="helpers.getPlaceholderResponsiveText('Please select owner', isMobile)"
            />
          </validation-provider>
        </form-row>
        <!-- REGISTERED -->
        <form-row
          id="registered-of-vehicle"
          :question="`Who is the registered keeper of the ${['car', 'bike', 'motorhome'].includes(productName) ? productName : 'vehicle'}?`"
        >
          <validation-provider
            v-slot="{ errors }"
            :vid="`${stepId}_registered-of-vehicle`"
            name="Registered of vehicle"
            rules="listOptionRequired"
          >
            <qz-select
              v-model="questionData.registeredOfVehicle"
              :data-test="fieldTrackerId.registeredOfVehicle"
              :items="vehicleRegisteredOfVehicle"
              :error-messages="errors"
              :placeholder="helpers.getPlaceholderResponsiveText('Please select registered keeper', isMobile)"
            />
          </validation-provider>
        </form-row>
      </template>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

import { createOptions } from '@/helpers/common';
import { snakeCase } from 'lodash';

export default {
  name: 'question-owned-registered',
  extends: QuestionBase,
  data () {
    return {
      ownerAndRegistered: true,
      fields: ['ownerOfVehicle', 'registeredOfVehicle'],
    };
  },
  created () {
    const {
      ownerOfVehicle,
      registeredOfVehicle,
    } = this.stepData;

    if (ownerOfVehicle && registeredOfVehicle) {
      this.ownerAndRegistered = (ownerOfVehicle === 1 && registeredOfVehicle === 1);
    }
  },
  computed: {
    vehicleOwnerOfVehicle () {
      const options = this.optionsConfig?.options || this.constants.COVER_OWNER_OF_VEHICLE;
      return createOptions({
        source: options,
        asNumbers: true,
      });
    },
    vehicleRegisteredOfVehicle () {
      const options = this.optionsConfig?.options || this.constants.COVER_REGISTERED_OF_VEHICLE;
      return createOptions({
        source: options,
        asNumbers: true,
      });
    },
    helpTextValue () {
      if (this.helpText) {
        return this.helpText.value || this.helpText;
      }
      return "<p>If your name is on the <strong>V5C 'log book'</strong> then you are the registered keeper.</p>";
    },
    fieldTrackerId () {
      return {
        ownerOfVehicle: snakeCase(this.questionFields.ownerOfVehicle),
        registeredOfVehicle: snakeCase(this.questionFields.registeredOfVehicle),
      };
    },
  },
  watch: {
    ownerAndRegistered (newVal) {
      if (newVal) {
        this.questionData[this.questionFields.ownerOfVehicle] = this.defaultValues.ownerOfVehicle || 1;
        this.questionData[this.questionFields.registeredOfVehicle] = this.defaultValues.registeredOfVehicle || 1;
      }
    },
  },
};
</script>
